import { useQuery } from '@tanstack/react-query';
import { getOptionValues } from '../../../api/apiOptionGroups';
import i18next from 'i18next';

/**
 * Hook to fetch option values for a specific option group
 */
export const useGetOptionValues = (optionGroupId, params = {}) => {
    const {
        data,
        error,
        isLoading,
        refetch
    } = useQuery({
        queryKey: ['optionValues', optionGroupId, params, i18next.language],
        queryFn: () => getOptionValues(optionGroupId, params),
        enabled: !!optionGroupId,
        retry: false,
    });

    return {
        optionValues: data?.data?.data || [],
        meta: data?.data?.meta || {},
        error,
        isLoading,
        refetch
    };
};
